"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasNftInAccounts = exports.INFINITY_PASS_COLLECTION_CONTRACT = exports.GENESIS_PASS_COLLECTION_CONTRACT = exports.orderByLastReceived = exports.groupByCurrency = exports.getNFT = exports.getNftCollectionKey = exports.getNftKey = exports.nftsByCollections = void 0;
const live_env_1 = require("@ledgerhq/live-env");
const account_1 = require("../account");
/**
 * Helper to group NFTs by their collection/contract.
 *
 * It will either return an object { [contract address]: NFT[] }
 * or if you specify a collectionAddress it will simply filter
 * your NFTs for this specific contract and return an NFT[].
 *
 * The grouping here can be done with ProtoNFT or NFT.
 */
const nftsByCollections = (nfts = [], collectionAddress) => {
    return collectionAddress
        ? nfts.filter(n => n.contract === collectionAddress)
        : nfts.reduce((acc, nft) => {
            const { contract } = nft;
            if (!acc[contract]) {
                acc[contract] = [];
            }
            acc[contract].push(nft);
            return acc;
        }, {});
};
exports.nftsByCollections = nftsByCollections;
const getNftKey = (contract, tokenId, currencyId) => {
    return `${currencyId}-${contract}-${tokenId}`;
};
exports.getNftKey = getNftKey;
const getNftCollectionKey = (contract, currencyId) => {
    return `${currencyId}-${contract}`;
};
exports.getNftCollectionKey = getNftCollectionKey;
const getNFT = (contract, tokenId, nfts) => nfts === null || nfts === void 0 ? void 0 : nfts.find(nft => nft.contract === contract && nft.tokenId === tokenId);
exports.getNFT = getNFT;
const groupByCurrency = (nfts) => {
    const groupMap = new Map();
    const SUPPORTED_CURRENCIES = (0, live_env_1.getEnv)("NFT_CURRENCIES").split(",");
    SUPPORTED_CURRENCIES.forEach(elem => groupMap.set(elem, []));
    // GROUPING
    nfts.forEach(nft => {
        var _a;
        const currency = nft.currencyId;
        const group = (_a = groupMap.get(currency)) !== null && _a !== void 0 ? _a : [];
        group === null || group === void 0 ? void 0 : group.push(nft);
        groupMap.set(currency, group);
    });
    return Array.from(groupMap, ([_key, value]) => value).flat();
};
exports.groupByCurrency = groupByCurrency;
function orderByLastReceived(accounts, nfts) {
    const orderedNFTs = [];
    let operationMapping = [];
    const res = (0, account_1.groupAccountsOperationsByDay)(accounts, {
        count: Infinity,
    });
    // Sections are sorted by Date, the most recent being the first
    res.sections.forEach(section => {
        // Get all operation linked to the reception of an NFT
        const operations = section.data.filter(d => d.type === "NFT_IN" && d.contract && d.tokenId);
        operationMapping = operationMapping.concat(operations);
    });
    operationMapping.forEach(operation => {
        // Prevent multiple occurences due to Exchange Send/Receive same NFT several times
        const isAlreadyIn = orderedNFTs.find(nft => nft.contract === operation.contract && nft.tokenId === operation.tokenId);
        if (!isAlreadyIn) {
            const nft = (0, exports.getNFT)(operation.contract, operation.tokenId, nfts);
            if (nft)
                orderedNFTs.push(nft);
        }
    });
    return (0, exports.groupByCurrency)([...new Set(orderedNFTs)]);
}
exports.orderByLastReceived = orderByLastReceived;
exports.GENESIS_PASS_COLLECTION_CONTRACT = "0x33c6Eec1723B12c46732f7AB41398DE45641Fa42";
exports.INFINITY_PASS_COLLECTION_CONTRACT = "0xfe399E9a4B0bE4087a701fF0B1c89dABe7ce5425";
const hasNftInAccounts = (nftCollection, accounts) => accounts &&
    accounts.some(account => { var _a; return (_a = account === null || account === void 0 ? void 0 : account.nfts) === null || _a === void 0 ? void 0 : _a.some((nft) => (nft === null || nft === void 0 ? void 0 : nft.contract) === nftCollection); });
exports.hasNftInAccounts = hasNftInAccounts;
//# sourceMappingURL=helpers.js.map